import { render, staticRenderFns } from "./headero.vue?vue&type=template&id=5e5fce87&scoped=true&"
import script from "./headero.vue?vue&type=script&lang=js&"
export * from "./headero.vue?vue&type=script&lang=js&"
import style0 from "./headero.vue?vue&type=style&index=0&id=5e5fce87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5fce87",
  null
  
)

export default component.exports